// extracted by mini-css-extract-plugin
module.exports = {"atm_mk_h2mmj6":"atm_mk_h2mmj6","atm_tk_1n1ank9":"atm_tk_1n1ank9"};